import * as React from "react";

const TextNext = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85.93 21.203">
      <title>NEXT</title>
      <path
        d="M2.813-20.719H4.766L18.344-5.562H18.5V-20.719h1.531V.484h-.812L4.516-16.359H4.391V0H2.813Zm39.81,0v1.344H31.7v7.406h7.312v1.344H31.7v9.281H42.622V0H28.216V-20.719ZM48.292,0H46.464L55.2-10.219l-7.969-10.5H51.37l6.016,7.953,6.781-7.953h1.844l-7.781,9.094L67.057,0H62.886L56.042-9.078ZM88.743-20.719v1.344h-7.5V0H77.758V-19.375h-7.5v-1.344Z"
        transform="translate(-2.813 20.719)"
        fill="inherit"
      />
    </svg>
  );
};

export default TextNext;
